import React, { ReactNode } from "react";
import CircularProgress from "@mui/material/CircularProgress";

import { ContainedButton } from "common/DS/Buttons";
import COLOR from "lib/colors";
import { DSButtonProps } from "./types";

type Props = {
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    disabled: boolean;
    loading: boolean;
    children: ReactNode;
    size?: DSButtonProps["size"];
};

const LoadingButton = ({ onClick, disabled, loading, children, size = "large" }: Props) => (
    // If you're looking at me in the future, check to see if  MUI has finally released
    // this: https://mui.com/material-ui/react-button/#loading-button

    <ContainedButton
        size={size}
        onClick={onClick}
        disabled={loading || disabled}
        data-test="next-button"
    >
        {loading && (
            <>
                <CircularProgress
                    variant="indeterminate"
                    size={10}
                    sx={{ color: COLOR["slate-grey"] }}
                />
                &nbsp;
            </>
        )}
        {children}
    </ContainedButton>
);

export default React.memo(LoadingButton);
